module.exports = __webpack_public_path__ + "media/images/lps-sell_investment-0caa25c8.png";